<!--
	TEMPLATE
-->
<template>

	<div class="editable-price">
		<div v-if="!isEditView">
			{{ this.formatCurrency(priceObj.price) }} <span v-if="options.serviceTypeId === serviceType.LETTINGS">({{priceObj.rentFrequency}})</span>
		</div>

		<div v-if="isEditView">
			<currency-input v-model="priceObj.price" :placeholder="'£'" @newValue="newValue" :class="{ 'editable-item__required': hasErrors }"></currency-input>

			<div class="editable-options__select" v-if="options.serviceTypeId === serviceType.LETTINGS && options.hideFrequencyDropdown">
				<select v-model="priceObj.rentFrequency">
					<option value="PCM">PCM</option>
					<option value="PW">PW</option>
			  </select>
			</div>
		</div>
	</div>

</template>

<!--
	SCRIPT
-->
<script>
import utils from '@/libs/mixins.js';
import vModelNested from '@/libs/vModelNested.js';
import CurrencyInput from '../../components/CurrencyInput.vue';

export default {
	props: {
		value: [Number, String, Object],
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
			hasErrors: false,
			serviceType: {
				 SALES: 1,
				 LETTINGS: 2
			}
		}
	},
	computed: {
		priceObj: vModelNested,
		price: function() {
			return this.priceObj.price;
		},
		newPrice: function() {
			return this.priceObj.newPrice;
		}
	},
	watch: {
		price: function() {
			this.hasErrors = this.price === 0 || this.price === undefined || this.price === '';
			this.$emit('hasErrors', this.hasErrors);
		},
		newPrice: function() {
			this.hasErrors = this.newPrice === 0 || this.newPrice === undefined || this.newPrice === '';
			this.$emit('hasErrors', this.hasErrors);
		}
	},
	mixins: [utils],
	components: {
		'currency-input': CurrencyInput
	},
	methods: {
		newValue(value) {
			this.priceObj.newPrice = value;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/editable-items/EditablePrice.vue